import React, { useState } from 'react';
import Button from '@/components/common/button';
import Select from '@/components/common/select';
import IconExpand from '@/assets/images/icons/icons-external-link.svg';
import IconCollapse from '@/assets/images/icons/icons-collapse.svg';
import { pageSizeOptions } from '@/components/base-table/table-settings';
import './style.scss';
import IconSearch from '@/assets/images/icons/icons-search1.svg';
import { Input } from 'antd';
import { ICON } from '@/components/common/icon/iconFlag';

const FilterView = ({
  metadata = {},
  onChangePageProps = {},
  expandAll = false,
  toggleExpandAllProp,
  isPagination = true,
  isExpandProp = true,
  filter,
  options,
  onSearch = () => {},
  placeholder,
  onRemoveFilter = () => {},
}) => {
  const [defaultParams] = useState(metadata);
  const [isExpand, setExpandAll] = useState(expandAll);
  const [searchValue, setSearchValue] = useState('');
  const [isShowFilter, setIsShowFilter] = useState(false);

  const handleExpandAll = (isReset = false) => {
    if (!isExpandProp) return;
    const isExpandVal = isReset && typeof isReset === 'boolean' ? false : !isExpand;
    setExpandAll(isExpandVal);
    toggleExpandAllProp(isExpandVal);
  };

  const handleSearch = () => {
    onSearch(searchValue);
  };

  const toggleFilter = () => {
    if (isShowFilter) {
      const { page, limit, search } = metadata;
      const pagination = isPagination ? { page, limit } : {};
      console.log(defaultParams, pagination);
      onChangePageProps({ ...defaultParams, search, ...pagination });
      onRemoveFilter({ ...defaultParams, search, ...pagination });
    }
    setIsShowFilter(!isShowFilter);
  };

  const onChangePageSize = (size) => {
    onChangePageProps({ ...metadata, page: 1, limit: size });
    handleExpandAll(true);
  };

  return (
    <div className="filter-view-container">
      <section>
        {isPagination && (
          <Select
            className="size-option"
            value={metadata?.limit}
            options={pageSizeOptions}
            onChange={onChangePageSize}
          />
        )}
        {options && options}
        {isExpandProp && (
          <Button
            className="expand-btn"
            icon={isExpand ? IconCollapse : IconExpand}
            fixedIcon
            onClick={handleExpandAll}
          >
            {isExpand ? 'Collapse all' : 'Expand all'}
          </Button>
        )}

        <div className="search">
          <Input
            placeholder={placeholder || 'Search'}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onPressEnter={handleSearch}
            onKeyDown={(e) => e?.nativeEvent?.key === 'Tab' && handleSearch()}
            autoFocus
            suffix={
              searchValue ? (
                <Button
                  type="text"
                  className="btn-clear"
                  onClick={() => {
                    setSearchValue('');
                    onSearch('');
                  }}
                  flagIcon={ICON.CLEAR}
                />
              ) : (
                <Button type="text" onClick={() => onSearch(searchValue)}>
                  <img className="icon" alt="search icon" src={IconSearch} />
                </Button>
              )
            }
          />
        </div>

        {filter && (
          <Button
            className={`btn-filter ${isShowFilter ? 'btn-filter-open' : ''}`}
            flagIcon={ICON.ICONS_CAP_DOWN}
            fixedIcon
            onClick={toggleFilter}
          >
            {isShowFilter ? 'Remove filters' : 'Show filters'}
          </Button>
        )}
      </section>
      {isShowFilter && <div className="filter-view">{filter}</div>}
    </div>
  );
};

export default FilterView;
